import {DashboardTileId} from '../types/DashboardTileId';
import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {DashboardTileSize} from '../types/DashboardTileSize';
import {applyDashboardGridLayout} from './applyDashboardGridLayout';
import {reconcileDashboardGrid} from './reconcileDashboardGrid';
import {resizeDashboardGrid} from './resizeDashboardGrid';

export function setDashboardTileSize(
  placements: DashboardTilePlacement[],
  id: DashboardTileId,
  size: DashboardTileSize,
  visibleIds: DashboardTileId[]
): DashboardTilePlacement[] {
  const active = placements.find((placement) => placement.id === id);

  if (active === undefined || active.size === size) {
    return placements;
  }

  const visibleIdSet = new Set(visibleIds);
  const visiblePlacements = placements.filter((placement) => visibleIdSet.has(placement.id));
  const positioned = reconcileDashboardGrid(visiblePlacements);
  const resized = resizeDashboardGrid(positioned, id, size);

  return resized === positioned ? placements : applyDashboardGridLayout(placements, resized);
}
